/**
 * @fileoverview: 勋章规则说明
 * @author: lipengyao
 */
import '@css/reset.css';
import './index.less';
import '@js/lib/object.assign';
import '@js/lib/promise';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Title from 'c-title';
import lang from '@js/lang';
import loadI18n from '@lang/loader';
import {GetType, AddUser} from '../_service/follwUser'
import Url from 'c-url';
import Native from 'c-up-native';
import VConsole from 'vconsole';

const env = Url.query('env');

if (env !== 'stage') {
    /* try {
        const appId = 'StMabAd1624964079290'
        UReport({
            domain: 'https://apm.upliveapp.com/api/v1/report/web', //你的api地址
            add: {
                appId
            }
        })
    }
    catch (e) {
        console.log(e)
    } */

} else {
    new VConsole();
}

let uid = 526412549;
const userHref = 'https://h5.upliveapp.com/uppro/index.html?env=pro&feature=0&lang={lang}&shareUid=526412549&sharePlatform=copy#/profile/526412549'

const format = (str) => {
    return lang.template(str).replace('May\'n', 'MAY\'N');
}

class FlashScreen extends Component {
    state = {};

    system = Native.getSystem();

    componentDidMount() {
        this.getType();
        // 监听原生返回 重新获取是否关注
        if (this.system == 'ios') {
            this.setupIOS();
        } else {
            this.setupAndroid();
        }
    }

    setupIOS = () => {
		let enterTime = Date.now();
        const closeSelf = () => {
            const now = Date.now();
            if (now - enterTime > 700) {
                this.getType();
            }
        };
        setInterval(() => {
            closeSelf();
            enterTime = Date.now();
        }, 200);
	}

	setupAndroid = () => {
		document.addEventListener('visibilitychange', () => {
            console.log(document.visibilityState)
            if (document.visibilityState === 'visible') {
                this.getType();
            }
        });
	}

    getType = () => {
        GetType(uid, this.props.usertoken).then((res) => {
            if (res && res.data && res.data.followType) {
                this.setState({followType: res.data.followType});
            } else {
                this.setState({followType: null});
            }
        });
    }
    goJump = () => {
        window.location.href = userHref.replace('{lang}', lang.lang);
    }
    addUser = () => {
        if (!this.props.usertoken) {
            this.goJump();
            return;
        }
        AddUser(uid, this.props.usertoken).then(res => {
            console.log(res)
            if (res && res.data && res.data.followType) {
                this.setState({followType: res.data.followType});
            } else {
                this.setState({followType: null});
            }
        })
    }
    goProfile = () => {
        if (!this.props.usertoken) {
            this.goJump();
            return;
        }
        Native.profile({uid, tab: 0});
    }

    componentDidUpdate() {
        console.log(this.state)
    }

    render() {
        const followType = this.state.followType;
        const isJp = lang.langType === 'jajp';
        const text = isJp ? '' : ', ';
        return (
            <div className="wrap flash-screen">
                <div className='img rules-1' />
                <div className='content'>
                    <div className='part1'>
                        <h1 className='pink '>{format('May\'n')}</h1>
                        <h1 className='pink size26'>{format('15周年纪念演唱会购票指南')}</h1>
                    </div>
                    <div className='part2'>
                        <h2 className='qing size15'>{format('在5月30日，日本的实力派女性歌手：')}</h2>
                        <h2 className='size19' dangerouslySetInnerHTML={{__html: format('May\'n将举办出道15周年纪念演唱会。').replace('MAY\'N', '<span class=\'qing\'>MAY\'N</span>')}}></h2>
                        <h2 className='qing size15 last'>{format('如何能看到May\'n的现场演唱会呢？')}</h2>
                    </div>
                    <div  className='part3 size11'>
                        <h2> {format('推荐提前关注')}<span className='qing size13'>{format('May\'n的官方账号')}</span>{text}{format('这样演唱会开始时可以第一时间收到通知。')}</h2>
                    </div>
                    <div className='part4'>
                        <h2 className='qing size11'>{format('点击下面的按钮可以直接关注May\'n')}</h2>
                        <div className='arrow' />
                        <div className='user-card' />
                        {
                            followType === 1
                            ? <a className='size15 button disabled'>{format('已关注')}</a>
                            : <a className='size15 button' onClick={this.addUser}>{format('关注')}</a>
                        }
                    </div>
                    <div className='part5'>
                        <div className='list'>
                            <span>1.</span>
                            <h2>{format('直播分为两回，GMT+8下午3:30是演唱会开始前的免费直播，到了GMT+8下午4:30直播会暂时关闭并切换到付费直播，15周年纪念演唱会现场直播正式开始。')}</h2>
                        </div>
                        <div className='list'>
                            <span>2.</span>
                            <h2>{format('和官方充值客服（ID：uplivevip_koko  ， uplivevipel  微信：kokohangz ，uplivevipel）联系，提前购买1250钻石，演唱会开始后直接进入直播间即可。')}</h2>
                            <h2>{format('请注意这种方法只适用于29日之前，30日当天可能无法对应充值。')}</h2>
                            <h2 className='qing'>{format('*选择官方充值的时候请注意对应客服是否有Vip充值客服认证')}</h2>
                        </div>
                        <div className='list'>
                            <span>3.</span>
                            <h2>{format('如果联系不到官方充值客服的情况下也可以使用软件内充值的方法，在个人页面点击钱包后选择对应金额进行充值。')}</h2>
                        </div>
                    </div>
                    <div className='part6'>
                        <h2 className='qing size9'>{format('点击下面的按钮可以进入May\'n个人页面')}</h2>
                        <div className='arrow' />
                        <a className='size15 button' onClick={this.goProfile}>{format('个人页')}</a>
                    </div>
                </div>




            </div>
        );
    }
}

Native.getConfigs({
    invalid: 1,
    complete: (opt) => {
        console.log(opt)
        const usertoken = opt.usertoken;
        loadI18n('flashScreen').then((msg) => {
            const title = format('May\'n 15周年纪念演唱会购票指南');
            //Title.set(title);
            document.title = title;
            Native.setTitle(title);
            ReactDOM.render(<FlashScreen usertoken={usertoken}/>, document.getElementById('wrap'));
        });
    }, 
    errtip: (err) => {
        console.log(err);
        loadI18n('flashScreen').then((msg) => {
            const title = format('May\'n 15周年纪念演唱会购票指南');
            //Title.set(title);
            document.title = title;
            Native.setTitle(title);
            ReactDOM.render(<FlashScreen/>, document.getElementById('wrap'));
        });
    }
})




// WEBPACK FOOTER //
// ./js/flashScreen/index.js